var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hold-pwd __pointer", on: { click: _vm.toggleHold } },
    [
      _c("span", { class: { active: _vm.isHoldPWD } }),
      _vm._v("\n    " + _vm._s(_vm.$t("pwdConfirm.conf")) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }